import { StatsigConfigurations } from '@confluence/statsig-client/entry-points/StatsigConfigurations.ts';
import { expVal } from '@confluence/feature-experiments';

export function getMultiMacroQueryBlocklistFF() {
	let blocklist = StatsigConfigurations.getStringList(
		'confluence_frontend_macros_query_blocklist',
		[
			'include',
			'jirachart',
			'jiraroadmap',
			'ui-button',
			'contentbylabel',
			'excerpt-include',
			'tasks-report-macro',
			'blog-posts',
			'section',
			'table-filter',
			'children',
			'pagetree',
			'detailssummary',
			'decisionreport',
		],
	);
	if (expVal('confluence_frontend_ssr_include_macro_exp', 'isEnabled', false)) {
		blocklist = blocklist.filter((macro) => macro !== 'include');
	}
	if (expVal('confluence_frontend_ssr_section_macro_exp', 'isEnabled', false)) {
		blocklist = blocklist.filter((macro) => macro !== 'section');
	}
	return String(blocklist).split(',');
}

export function canUseMultiMacroQuery(
	extensionKey: string | undefined,
	isNested2pBodiedExtension = false,
) {
	return (
		!isNested2pBodiedExtension && !getMultiMacroQueryBlocklistFF().includes(extensionKey || '')
	);
}
